import { isOnNodeJS } from "common/utils/context";
import type { AssetLoader } from "doc/plans/assetLoader";
import type { Vec2 } from "geom/vec2";
import { BrowserAssetLoader } from "./browserAssetLoader";

// This is a PER-THREAD instance of the asset loader.
// That means web workers will have a different instance than the main thread.
// We actually exploit this to our advantage by setting the webworkerFetchImageSize function
// to specialize image size calculations for web workers.
let assetLoader: AssetLoader | undefined;

export async function assetLoaderInstance(
  webworkerFetchImageSize?: (url: string) => Promise<Vec2>,
): Promise<AssetLoader> {
  if (!assetLoader) {
    if (isOnNodeJS()) {
      const NodeAssetLoader = (await import("./nodeAssetLoader")).default;
      assetLoader = new NodeAssetLoader(process.cwd());
    } else {
      assetLoader = new BrowserAssetLoader(webworkerFetchImageSize);
    }
  }
  return assetLoader;
}
